"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AccordionGalleryImage", {
    enumerable: true,
    get: function() {
        return AccordionGalleryImage;
    }
});
var _react = _interop_require_default(require("react"));
var _components = require("@cmpsr/components");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    from { opacity: 0; }\n    to   { opacity: 1; }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var AccordionGalleryImage = function(props) {
    if (!props) return;
    var opacity = (0, _components.keyframes)(_templateObject());
    var opacityAnimation = "".concat(opacity, " 0.5s linear");
    return _react.default.createElement(_components.Box, {
        animation: opacityAnimation,
        key: props.src
    }, _react.default.createElement(_components.Image, _object_spread({
        alt: "Accordion Illustration",
        margin: {
            base: "0 auto",
            md: "unset"
        }
    }, props)));
};
